import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as UserService from '_services/user-service';
import * as BookingService from '_services/booking-service';
import * as ReviewService from '_services/review-service';
import * as BeaconService from '_services/beacons-service';

const initialState = {
  uuid: null,
  userProfile: null,
  userDb: null,
  userBookings: [],
  selectedBooking: null,
  reviewHistory: [],
  beaconHistory: [],
  status: 'idle',
  error: null,
};

// get user profile info
export const getUserProfileInformation = createAsyncThunk('userProfile/getUserProfileInformation', async (uuid) => {
  return UserService.getFirebaseInfo(uuid);
});

export const getUserDbInfo = createAsyncThunk('userProfile/getUserDbInfo', async (uuid) => {
  return UserService.getUserDbInfo(uuid);
});

export const getUserBookings = createAsyncThunk('userProfile/getUserBookings', async (uuid) => {
  return BookingService.getUserBookingList(uuid);
});

export const getUserReviewHistory = createAsyncThunk('userProfile/getUserReviewHistory', async (params) => {
  return ReviewService.getUserReviewHistory(params);
});

export const getUserBeaconHistory = createAsyncThunk('userProfile/getUserBeaconHistory', async (uuid) => {
  return BeaconService.getUserBeaconHistory(uuid);
});

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    reset: (state) => initialState,
    setUser: (state, action) => {
      state.uuid = action.payload;
    },
    setSelectedBooking: (state, action) => {
      state.selectedBooking = action.payload
    }
  },
  extraReducers: {
    [getUserProfileInformation.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading'
      }
    },
    [getUserProfileInformation.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        userProfile: action.payload
      }
    },
    [getUserProfileInformation.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        error: action.error.message
      }
    },
    [getUserDbInfo.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading'
      }
    },
    [getUserDbInfo.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        userDb: action.payload
      }
    },
    [getUserDbInfo.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        error: action.error.message
      }
    },
    [getUserBookings.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading'
      }
    },
    [getUserBookings.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        userBookings: action.payload
      }
    },
    [getUserBookings.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        error: action.error.message
      }
    },
    [getUserReviewHistory.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading'
      }
    },
    [getUserReviewHistory.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        reviewHistory: action.payload
      }
    },
    [getUserReviewHistory.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        error: action.error.message
      }
    },
    [getUserBeaconHistory.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading'
      }
    },
    [getUserBeaconHistory.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        beaconHistory: action.payload
      }
    },
    [getUserBeaconHistory.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        error: action.error.message
      }
    }
  }
});

/*
              {
                Header: <TableHeader title={'Flight'} />,
                accessor: "flightNumber",
                Cell: ({cell:{value}}) => <TableValue title={value} />
              },
              {
                Header: <TableHeader title={'Reference'} />,
                accessor: "referenceNumber",
                Cell: ({cell:{value}}) => <TableValue title={value} />
              },
              {
                Header: <TableHeader title={'Arrival'} />,
                accessor: "arrivalTime",
                Cell: ({cell:{value}}) => <TableValue title={!isNaN( new Date(value).getTime()) ? format(new Date(value), "h:mm a") : 'N/A'} />
              },
              {
                Header: <TableHeader title={'Departure'} />,
                accessor: "departureTime",
                Cell: ({cell:{value}}) => <TableValue title={!isNaN( new Date(value).getTime()) ? format(new Date(value), "h:mm a") : 'N/A'} />
              },
              {
                Header: <TableHeader title={'Date'} />,
                accessor: "departureDate",
                Cell: ({cell:{value}}) => <TableValue title={value} />
              },

              {
                Header: <TableHeader title={'Notes'} />,
                accessor: 'bio',
                // render custom object
                Cell: ({cell:{value}}) => <div><PRMBIO title={value} comment={true} /></div>
              },
              {
                Header: <TableHeader title={'Time Created'} />,
                accessor: "dateCreated",
                Cell: ({cell:{value}}) => {
                    if(new Date(value) != 'Invalid Date') {
                        return <p style={{opacity:0.4, marginLeft:10, marginTop:5}}>{new Date(value).toLocaleTimeString().substring(0, 5) + ' ' + new Date(value).toLocaleDateString()}</p>
                    } else {
                        return null
                    }
                },
            },
            */

export const selectUserBookings = state => {
  if (state.userProfile.userBookings == null || state.userProfile.userBookings == undefined || state.userProfile.userBookings == []) { return [] }

  let list = []

  state.userProfile.userBookings.forEach((booking) => {
    list.push({
      'name': booking.name ? booking.name : "",
      'flightNumber': booking.flightDetails ? booking.flightDetails.carrierCode + booking.flightDetails.flightNumber : "",
      'origin': booking.flightConfirmationDetails ? booking.flightConfirmationDetails.origin : "",
      'destination': booking.flightConfirmationDetails ? booking.flightConfirmationDetails.destination : "",
      'assistance': booking.assistance ? booking.assistance : [],
      'bio': booking.bio ? booking.bio : "",
      'referenceNumber': booking.reference ? booking.reference : '',
      'dateCreated': booking.dateCreated ? booking.dateCreated : null,
      'departureDate': booking.flightConfirmationDetails ? booking.flightConfirmationDetails.departureDate : null,
      'airlineConfirmed': booking.airlineConfirmed ? booking.airlineConfirmed : null,
      'destinationAssistance': booking.destinationAssistance ? booking.destinationAssistance : null,
      'destinationConfirmed': booking.destinationConfirmed ? booking.destinationConfirmed : null,
      'originAssistance': booking.originAssistance ? booking.originAssistance : null,
      'originConfirmed': booking.originConfirmed ? booking.originConfirmed : null,
      'status': booking.status ? booking.status : '',
      'departureTime': booking.flightConfirmationDetails && booking.flightConfirmationDetails.departureTime ? booking.flightConfirmationDetails.departureTime : '',
      'arrivalTime': booking.flightConfirmationDetails && booking.flightConfirmationDetails.arrivalTime ? booking.flightConfirmationDetails.arrivalTime : ''
    })
  })

  return list;
};

// creates list of reviews for table
export const selectUserReviewHistory = state => {
  if (state.userProfile.reviewHistory == null || state.userProfile.reviewHistory == undefined || state.userProfile.reviewHistory == []) { return [] }

  let list = [];

  const createListObject = (props) => {
    return (
      {
        "count": props.index,
        "flight": props.flight.details.carrierCode + props.flight.details.flightNumber,
        "date": props.flight.details.departureDate,
        "assistanceQuality": props.review.review.quality,
        "staffAssistance": props.review.review.staff,
        "comments": props.review.review.comments,
        "airport": props.review.details.iata,
        "type": props.type,
      }
    )
  }

  let index = 0;

  state.userProfile.reviewHistory.forEach((review) => {
    if (review) {
      list.push(createListObject({ 'review': review.departure, 'flight': review.flight, 'index': index, type: 'Departure' }))
      list.push(createListObject({ 'review': review.arrival, 'flight': review.flight, 'index': index, type: 'Arrival' }))
      list.push(createListObject({ 'review': review.flight, 'flight': review.flight, 'index': index, type: 'Airline' }))
      index++
    }
  })

  return list
};

export const selectBookingReview = state => {
  if (state.userProfile.userBookings == null || state.userProfile.userBookings == undefined || state.userProfile.userBookings == []) { return [] }
  if (state.userProfile.reviewHistory == null || state.userProfile.reviewHistory == undefined || state.userProfile.reviewHistory == []) { return [] }

  let match;

  // try find a match for the review
  state.userProfile.reviewHistory.forEach((review) => {
    state.userProfile.userBookings.forEach((booking) => {
      if (booking.id == review.bookingId) {
        match = review;
      }
    })

  })

  return match;
};

export const selectSelectedBooking = state => state.userProfile.selectedBooking;
export const selectUserBeaconHistory = state => state.userProfile.beaconHistory;
export const selectUserUUID = state => state.userProfile.uuid;


export const { reset, setUser, setSelectedBooking } = userProfileSlice.actions;
export const selectUserProfile = state => state.userProfile.userProfile;
export const selectUserDb = state => state.userProfile.userDb;
export const selectUserStatus = state => state.userProfile.status;
export default userProfileSlice.reducer;
